import Vue from 'vue';

Vue.component('search-page', () => import(/* webpackChunkName: "search-page" */ './Page'));
